import script from "./TutorQuizBuilderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorQuizBuilderPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__